export default {
  dashboard: {
    notes: 'Label of dashboard link in sidebar',
    message: 'Dashboard',
  },
  company: {
    notes: 'Label of company link in sidebar',
    message: 'Companies',
  },
  site: {
    notes: 'Label of site link in sidebar',
    message: 'Sites',
  },
  equipment: {
    notes: 'Label of equipment link in sidebar',
    message: 'Equipment',
  },
  user: {
    notes: 'Label of user link in sidebar',
    message: 'Users',
  },
  role: {
    notes: 'Label of role link in sidebar',
    message: 'Roles',
  },
  samClientAccount: {
    notes: 'Label of My SAM client account link in sidebar',
    message: 'My SAM client accounts',
  },
  samAccount: {
    notes: 'Label of My SAM account link in sidebar',
    message: 'SAM account',
  },
};
